export default {
  data: {
    payment: {
      checkoutUrl:
        'https://pay.beltegoed.nl/pay/adyen/visa/payment/init/121008703/0/1580138346/9fa364fa577d382000b08f16c861a4bbe5c20335/nl',
    },
  },
}
